import WaterMark from "l-watermark";
import store from "@/store";

// 水印配置
export const getWatermarkConfig = () => {
  let userInfo = store.getters["user/userInfo"];
  let text = userInfo ? `${userInfo.no || ''} ${userInfo.nickName || ''}` : ''

  return {
    text,
    color: "rgba(0, 0, 0, 0.05)",
    fontSize: 14,
    cSpace: 50,
    vSpace: 50,
  }
}

/**
 * 页面水印导航守卫
 * @param {*} router 
 */
export default function watermarkGuard(router) {
  router.afterEach(async (to, from) => {
    if (window.waterMark) {
      window.waterMark.remove();
      window.waterMark = null;
    }

    let isInIframe = window.self !== window.top;
    let isHidenWatermark = to.meta.hidenWatermark;

    if (isInIframe || isHidenWatermark) {
      return;
    }

    window.waterMark = WaterMark.page({
      target: document.body,
      ...getWatermarkConfig(),
    });
  });
}